const RECIPIENT_INFORMATIONS = {
    ACCOUNT: "{RECIPIENT_ACCOUNT}",
    ADDRESS: "{RECIPIENT_ADDRESS}",
    BIRTHDATE: "{RECIPIENT_BIRTHDATE}",
    COUNTRY: "{RECIPIENT_COUNTRY}",
    COUNTY: "{RECIPIENT_COUNTY}",
    CITY: "{RECIPIENT_CITY}",
    COMPANY: "{RECIPIENT_COMPANY_NAME}",
    PHONE: "{RECIPIENT_COMPANY_PHONE}",
    EMAIL: "{RECIPIENT_EMAIL}",
    FAX: "{RECIPIENT_FAX_NUMBER}",
    FIRST_NAME: "{RECIPIENT_FIRST_NAME}",
    HOME: "{RECIPIENT_HOME_NUMBER}",
    LAST_NAME: "{RECIPIENT_LAST_NAME}",
    MOBILE: "{RECIPIENT_MOBILE_NUMBER}",
    SALUTATION: "{RECIPIENT_SALUTATION}",
    STATE: "{RECIPIENT_STATE}",
    TITLE: "{RECIPIENT_TITLE}",
    WORK: "{RECIPIENT_WORK_NUMBER}",
    ZIPCODE: "{RECIPIENT_ZIPCODE}",
    FULL_NAME: "{RECIPIENT_FIRST_NAME} {RECIPIENT_LAST_NAME}",
    FULL_NAME_ALT: "{RECIPIENT_LAST_NAME} {RECIPIENT_FIRST_NAME}"
};

const REPLACEMENT_CLASSES = {
    FULL_NAME: "rec-full-names",
    FULL_NAME_ALT: "rec-full-names-alt",
    FIRST_NAME: "rec-first-names",
    LAST_NAME: "rec-last-names",
    COMPANY: "rec-company-names",
    ACCOUNT: "rec-accounts",
    ADDRESS: "rec-addresses",
    BIRTHDATE: "rec-birthdates",
    COUNTRY: "rec-countries",
    COUNTY: "rec-counties",
    ZIPCODE: "rec-zipcodes",
    SALUTATION: "rec-salutations",
    CITY: "rec-cities",
    PHONE: "rec-phones",
    EMAIL: "rec-emails",
    FAX: "rec-faxes",
    HOME: "rec-homes",
    MOBILE: "rec-mobiles",
    STATE: "rec-states",
    TITLE: "rec-titles",
    WORK: "rec-works"
};

export default {
    RECIPIENT_INFORMATIONS,
    REPLACEMENT_CLASSES
};
